import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { ViewList, ViewModule } from '@mui/icons-material';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
export var ViewType;
(function (ViewType) {
    ViewType["TABLE"] = "TABLE";
    ViewType["GRID"] = "GRID";
})(ViewType || (ViewType = {}));
const Root = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    minHeight: 60,
}));
const CustomViewToggle = ({ handleChangeView, value }) => (_jsx(Root, { children: _jsxs(ToggleButtonGroup, Object.assign({ value: value, exclusive: true, onChange: (_, nextView) => handleChangeView(nextView) }, { children: [_jsx(ToggleButton, Object.assign({ value: ViewType.TABLE, title: "Table", "aria-label": "table" }, { children: _jsx(ViewList, {}) })), _jsx(ToggleButton, Object.assign({ value: ViewType.GRID, title: "Grid", "aria-label": "grid" }, { children: _jsx(ViewModule, {}) }))] })) }));
export default CustomViewToggle;
//# sourceMappingURL=index.js.map